import React from "react";
import { ProtectContext } from "../../context/protect_context";
import type { FooterButton } from "../../types";

export const Resource = () => {
  const { data } = React.useContext(ProtectContext);
  const footerData: any = data?.footer?.data;

  if (!footerData) return null;

  return (
    <section className={` bg-[${footerData.backgroundColor}] py-20`}>
      <div className="mx-auto w-full max-w-5xl px-4 text-center lg:px-8">
        <div className="mx-auto max-w-3xl">
          {footerData?.data?.title && (
            <h3 className="text-3xl font-bold text-gray-900 lg:text-4xl">
              {footerData?.data?.title}
            </h3>
          )}
        </div>
        {footerData?.data?.buttons && footerData?.data?.buttons?.length > 0 && (
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            {footerData?.data?.buttons?.map((button: FooterButton, index: number) => {
              // Apply specific gradient to second button (index 1)
              const isSecondButton = index === 1;
              const backgroundStyle = isSecondButton
                ? "linear-gradient(100deg, #0093e9 0, #80d0c7 95%)"
                : button.color
                ? `linear-gradient(to right, ${button.color.trim()}, ${button.color.trim()}dd)`
                : "linear-gradient(to right, #f97316, #ef4444)";

              const boxShadowStyle = isSecondButton
                ? "0 10px 15px -3px rgba(0, 147, 233, 0.4)"
                : button.color
                ? `0 10px 15px -3px ${button.color.trim()}40`
                : "0 10px 15px -3px rgba(249, 115, 22, 0.4)";

              return (
                <a
                  key={index}
                  href={button.href || button.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full px-8 py-3 text-sm font-semibold text-white shadow-lg transition hover:opacity-90  hover:-translate-y-1 duration-300"
                  style={{
                    background: backgroundStyle,
                    boxShadow: boxShadowStyle,
                  }}
                >
                  {button.title}
                </a>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};
